import { Container } from "@mui/material";
import { Stack } from "@mui/system";
import FiltersCifa from "components/cifa/filters_cifa";
import TableCifa from "components/cifa/table_cifa";
import { CustomLabel } from "components/shared";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "routes/constants";
import useCifaStore, { ICifaForm } from "stores/cifa/cifa.store";
import useListagemCifaStore from "stores/cifa/listagemCifa.store";

export default function StateManagerCifa(): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();

  // Extrai o ano da rota, ex: /service_management/cifa-2027 => 2027
  const match = /cifa-(\d{4})/.exec(location.pathname);
  const anoReferencia = match ? Number(match[1]) : 2026;

  const { getListCifas, meta, filtros } = useListagemCifaStore();
  const { setCifa } = useCifaStore();

  const loadCifas = (page = 1, limit = 10) => {
    const filters = [];

    if (filtros.institution) {
      filters.push({
        field: 'institution.name' as const,
        operator: '$ilike' as const,
        value: `%${filtros.institution}%`
      });
    }

    if (filtros.formulario_status) {
      filters.push({
        field: 'formulario_status' as const,
        operator: '$eq' as const,
        value: filtros.formulario_status
      });
    }

    if (filtros.responsavel) {
      filters.push({
        field: 'responsavel.name' as const,
        operator: '$ilike' as const,
        value: `${filtros.responsavel}`
      });
    }

    getListCifas(anoReferencia, {
      page,
      limit,
      filters
    });
  }

  useEffect(() => {
    loadCifas();
    // eslint-disable-next-line
  }, [anoReferencia]);

  const handleApplyFilters = () => {
    loadCifas(1, meta.itemsPerPage);
  };

  const handlePageChange = (page: number, limit: number) => {
    loadCifas(page, limit);
  };

  const handleViewCifa = (cifa: ICifaForm) => {
    if (cifa.ano_referencia === 2026) {
      setCifa(cifa);
      navigate(ROUTES.VIEW_CIFA_2026);
    } else if (cifa.ano_referencia === 2027) {
      setCifa(cifa);
      navigate(ROUTES.VIEW_CIFA_2027);
    }
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Stack spacing={3}>
        <CustomLabel
          text={`Municípios – CIFA ${anoReferencia}`}
          labelStyle={{
            fontFamily: 'Roboto',
            fontSize: '22px',
            fontWeight: 500,
            letterSpacing: '0.15px',
            lineHeight: '35.2px',
            textAlign: 'left',
          }}
        />

        <FiltersCifa onApplyFilters={handleApplyFilters} year={anoReferencia} />

        <TableCifa
          onViewCifa={handleViewCifa}
          onPageChange={handlePageChange}
        />
      </Stack>
    </Container>
  )
}
